/**
 * 打卡活动相关接口（与小程序 xf_crm_mini 保持一致，同一配置双端使用）
 */
import request from '@/utils/request'

const PREFIX = '/signstore'

/** 根据活动编码获取活动详情 */
export function getSignStoreActivityDetailByCode(params) {
  return request.get(PREFIX + '/activity/detailByCode', { params })
}

/** 根据活动ID获取活动详情 */
export function getSignStoreActivityDetail(params) {
  return request.get(PREFIX + '/activity/detail', { params })
}

/**
 * 验证电子印章点位（统一打卡接口，与小程序完全一致）
 * @param {Object} data { ruleCode, touchPoints, activityUserId, operationType?, pointIndex? }
 * @returns {Promise<{ matched, errorMessage? }>}
 */
export function validateSeal(data) {
  return request.post(PREFIX + '/sealrule/compareSimilarity', data)
}

/** 获取或创建用户活动参与记录（小程序 / Token 场景） */
export function getOrCreateUserRecord(params) {
  return request.get(PREFIX + '/activityUser/getOrCreate', { params })
}

/** 获取或创建用户活动参与记录（H5 匿名用户，使用 h5Uuid 作为标识） */
export function getOrCreateUserRecordH5(params) {
  return request.get(PREFIX + '/activityUser/h5/getOrCreate', { params })
}

/** 查询用户已打卡的点位列表 */
export function getCheckedPoints(params) {
  return request.get(PREFIX + '/activityUser/checkedPoints', { params })
}
